import { GetDealDetailsForInitiatedModalEffects } from './customer-info-effects';

export const WriteupSharedStateEffects: any[] = [
    GetDealDetailsForInitiatedModalEffects 
];
